import { getRequest } from '@/core';
import { cargoCarriers } from '@/requests';

export default async function getCargoCarriersRequest() {
	let url = cargoCarriers.getPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
